import React, { useState } from 'react';

import { CREW_PAGE_SIZE } from '../../const';
import { ASSISTANT_TEXTS } from '../../texts';
import DriverResultCard from '../DriverResultCard';

import styles from './styles.module.css';

const CrewMemberList = ({ crewMembers }) => {
	const [visibleCount, setVisibleCount] = useState(CREW_PAGE_SIZE);

	const visible = crewMembers.slice(0, visibleCount);
	const remaining = crewMembers.length - visibleCount;

	const handleShowMore = () => setVisibleCount((c) => c + CREW_PAGE_SIZE);

	return (
		<div className={styles.wrapper}>
			<div className={styles.grid}>
				{visible.map((member) => (
					<DriverResultCard key={member.id} crewMember={member} />
				))}
			</div>
			{remaining > 0 && (
				<button type="button" className={styles.showMoreBtn} onClick={handleShowMore}>
					<span className={styles.dots} aria-hidden="true">
						•••
					</span>
					{ASSISTANT_TEXTS.showMoreCrew(remaining)}
				</button>
			)}
		</div>
	);
};

export default CrewMemberList;
